export default __webpack_public_path__ + "static/media/token1.112c8d4e.svg";